import React from "react";
import styles from "./HowItWorks.module.css";
import { WHATSAPP_LINK } from "../siteData";

const STEPS = [
  {
    number: "01",
    title: "Message Us on WhatsApp",
    desc: "Tell us what needs doing — cleaning, renovation, or both — and send a few photos if you have them.",
  },
  {
    number: "02",
    title: "Get a Free Quote",
    desc: "We give you a clear price based on the job, with no hidden charges.",
  },
  {
    number: "03",
    title: "Schedule the Job",
    desc: "Pick a date and time that works for you — we'll confirm and show up on time.",
  },
  {
    number: "04",
    title: "Job Done, Space Ready",
    desc: "Our team gets to work and leaves your property clean, repaired, or renovated as agreed.",
  },
];

export default function HowItWorks() {
  return (
    <section className={styles.section}>
      <div className="container">
        <div className={styles.heading}>
          <p className="jc-eyebrow">How It Works</p>
          <h2 className={styles.title}>Booking is a simple, four-step process</h2>
          <p className={styles.desc}>
            No long forms or waiting around — just message us and we take it
            from there.
          </p>
        </div>

        <div className={styles.steps}>
          {STEPS.map((step, index) => (
            <div className={styles.step} key={step.number}>
              <div className={styles.stepNumber}>{step.number}</div>
              <h3 className={styles.stepTitle}>{step.title}</h3>
              <p className={styles.stepDesc}>{step.desc}</p>
              {index < STEPS.length - 1 && (
                <span className={styles.connector} aria-hidden="true" />
              )}
            </div>
          ))}
        </div>

        <div className={styles.ctaRow}>
          <a
            href={WHATSAPP_LINK}
            target="_blank"
            rel="noreferrer"
            className="jc-btn jc-btn-primary"
          >
            Start on WhatsApp
          </a>
        </div>
      </div>
    </section>
  );
}
